import { createActionNameForProcessingFetch } from '../../utils/helpers/actionCreatorHelpers';

import { JOB_APPLICATIONS_DOMAIN_NAME } from './constants';

// eslint-disable-next-line import/prefer-default-export

// eslint-disable-next-line import/prefer-default-export
export const getJobApplicationsConstants = createActionNameForProcessingFetch('getJobApplications', JOB_APPLICATIONS_DOMAIN_NAME);
